import { Box, Typography, TableCell, TableRow, IconButton } from "@mui/material";
import { Favorite } from "@mui/icons-material";
import { stylesCoinRow as styles } from "./stylesCoinRow";
import BullSvg from "../../../../assets/svg/BullSvg";
import BearSvg from "../../../../assets/svg/BearSvg";
import fallbackImage from "@/assets/image/fallback.png";
import { useGetCompanyLogoQuery } from "@/store/api/trendingStocksApi";
import { useNavigate } from "react-router-dom";
import RemoeSvg from "@/assets/svg/RemoveSvg";
import { navigateWithParams } from "@/helpers/navigation";
import { useRemoveFromFocusMutation } from "@/store/api/focusListApi";

type CoinRowProps = {
  coin: {
    name: string;
    symbol: string;
    price: string;
    change: number;
    sentiment: number;
    likes: string;
    posts: number;
    focus: boolean;
    percent: number;
  };
  queryParams: Record<string, any>;
};

export const CoinRow = ({ coin, queryParams }: CoinRowProps) => {
  const { name, symbol, price, change, sentiment, likes, percent } = coin;

  const { data: logoUrl } = useGetCompanyLogoQuery(symbol);
  const IconColor: "#008001" | "#CE212B" = sentiment > 0 ? "#008001" : "#CE212B";
  const ChangeColor: "#008001" | "#CE212B" = change > 0 ? "#008001" : "#CE212B";
  const SentimentIcon = sentiment > 0 ? BullSvg : BearSvg;
  const navigate = useNavigate();
  const handleClick = () => {
    navigateWithParams(navigate, "stock", queryParams, coin.symbol);
  };
  const [removeFromFocus] = useRemoveFromFocusMutation();
  const RemoveClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await removeFromFocus(symbol).unwrap();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <TableRow sx={styles.coinRow} onClick={() => handleClick()}>
      <TableCell sx={styles.tableCell}>
        <Box sx={styles.nameCellBox}>
          <Box sx={styles.icon}>
            <img
              src={logoUrl ? `https://eodhd.com/${logoUrl}` : fallbackImage}
              alt={symbol}
              style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "50%" }}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = fallbackImage;
              }}
            />
          </Box>

          <Box>
            <Typography noWrap sx={styles.nameText}>
              {name}
            </Typography>
            <Typography sx={styles.symbolText}>
              {symbol}{" "}
              <span style={{ color: ChangeColor }}>
                {change} ({percent < 0 ? percent * -1 : percent}%)
              </span>
            </Typography>
          </Box>
        </Box>
      </TableCell>

      <TableCell sx={styles.tableCell}>
        <Box sx={styles.CellBox}>
          <Typography sx={styles.priceText}>{price}</Typography>
        </Box>
      </TableCell>

      <TableCell sx={styles.tableCell}>
        <Box sx={styles.CellBox}>
          <Favorite sx={styles.like} fontSize="small" />
          <Typography sx={styles.likeText}>{likes}</Typography>
        </Box>
      </TableCell>

      <TableCell sx={styles.tableCell}>
        <Box sx={styles.CellBox}>
          <Typography sx={styles.postsText}>{coin.posts}</Typography>
        </Box>
      </TableCell>

      <TableCell sx={styles.tableCell}>
        <Box sx={{ ...styles.sentimentBox(IconColor), ...styles.CellBox }}>
          {/* {sentiment > 0 && ( */}
          <>
            <Typography sx={styles.sentimentText}>
              {sentiment <= 0 ? sentiment.toFixed(1) : "+" + sentiment.toFixed(1)}
            </Typography>

            <Box sx={styles.sentimentIconBox}>
              <SentimentIcon />
            </Box>
          </>
          {/* )} */}
        </Box>
      </TableCell>
      <TableCell sx={styles.tableCell}>
        <Box sx={{ ...styles.CellBoxIcon, ...styles.CellBoxIconRemoe }}>
          <IconButton onClick={RemoveClick}>
            <RemoeSvg />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  );
};
